import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.investment.committee');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-investment-committee',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.investment.committee/view.scss */
:host {
  display: block;
  min-height: 100%;
}

:host ::ng-deep .review-answer {
  line-height: 1.65;
  overflow-wrap: anywhere;
}

:host ::ng-deep .review-answer img {
  max-width: 100%;
  height: auto;
}

:host ::ng-deep .review-answer table {
  width: 100%;
  border-collapse: collapse;
}

:host ::ng-deep .review-answer th,
:host ::ng-deep .review-answer td {
  border: 1px solid #e4e4e7;
  padding: 6px 8px;
}`],
})
export class PageInvestmentCommitteeComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public token: string = '';
    public loading: boolean = true;
    public saving: boolean = false;
    public saved: boolean = false;
    public error: string = '';

    public company: any = null;
    public stage: string = '';
    public stageLabel: string = '';
    public meetingDate: string = '';
    public location: string = '';
    public member: any = null;
    public documents: any[] = [];
    public referenceDocuments: any[] = [];
    public reviewPacket: any = { documents: [], questions: [] };

    public async ngOnInit() {
        await this.service.init();
        await this.service.loading.hide();
        this.token = WizRoute.segment.token || '';
        if (!this.token) {
            this.error = '유효하지 않은 링크입니다.';
            this.loading = false;
            await this.service.render();
            return;
        }
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call('verify', { token: this.token });
        if (code !== 200) {
            this.error = data?.message || '심의 정보를 확인할 수 없습니다.';
            this.loading = false;
            await this.service.render();
            return;
        }
        this.applyData(data.data);
        this.loading = false;
        await this.service.render();
    }

    private applyData(data: any) {
        this.company = data.company;
        this.stage = data.stage;
        this.stageLabel = data.stage_label;
        this.meetingDate = data.meeting_date || '';
        this.location = data.location || '';
        this.member = data.member || {};
        this.documents = data.documents || [];
        this.referenceDocuments = data.reference_documents || [];
        this.reviewPacket = data.review_packet || { documents: [], questions: [] };
    }

    public payload() {
        if (this.stage === 'pre') {
            return { vote_open_main: this.member.vote_open_main || 'pending', opinion: this.member.opinion || '' };
        }
        if (this.stage === 'compliance') {
            return { approval: this.member.approval || 'pending', opinion: this.member.opinion || '' };
        }
        return { vote: this.member.vote || 'pending', minutes: this.member.minutes || '' };
    }

    public async submit() {
        if (!this.member) return;
        if (this.stage === 'pre' && (!this.member.vote_open_main || this.member.vote_open_main === 'pending')) {
            this.service.alert.error('본투심 개최 찬반을 선택하세요.');
            return;
        }
        if (this.stage === 'compliance' && (!this.member.approval || this.member.approval === 'pending')) {
            this.service.alert.error('승인 여부를 선택하세요.');
            return;
        }
        if (this.stage === 'main' && (!this.member.vote || this.member.vote === 'pending')) {
            this.service.alert.error('투자 찬반을 선택하세요.');
            return;
        }
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('submit', {
            token: this.token,
            data: JSON.stringify(this.payload())
        });
        this.saving = false;
        if (code !== 200) {
            this.service.alert.error(data?.message || '저장에 실패했습니다.');
            await this.service.render();
            return;
        }
        this.applyData(data.data);
        this.saved = true;
        this.service.alert.success('저장되었습니다.');
        await this.service.render();
    }

    public decisionLabel(value: string): string {
        const map: any = { pending: '미정', approve: '찬성', reject: '반대', abstain: '기권', approved: '승인', rejected: '부결', hold: '보류' };
        return map[value] || value || '미정';
    }

    private numberValue(value: any): number {
        if (typeof value === 'string') {
            const match = value.replace(/,/g, '').match(/-?\d+(\.\d+)?/);
            if (!match) return 0;
            value = match[0];
        }
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : 0;
    }

    private fieldValue(source: any, keys: string[], fallback: any = ''): any {
        if (!source || typeof source !== 'object') return fallback;
        for (const key of keys) {
            if (Object.prototype.hasOwnProperty.call(source, key) && source[key] !== undefined && source[key] !== null && source[key] !== '') {
                return source[key];
            }
        }
        return fallback;
    }

    public llmReviewResult(): any {
        return this.reviewPacket?.llm_review_result || {};
    }

    public llmReviewScore(): number {
        const direct = this.numberValue(this.fieldValue(this.llmReviewResult(), ['total_score', 'score', 'score_total', 'totalScore', 'total', '점수', '총점'], 0));
        if (direct > 0) return direct;
        return this.llmReviewItems().reduce((sum: number, item: any) => sum + this.numberValue(item?.score), 0);
    }

    public llmReviewMaxScore(): number {
        return this.numberValue(this.fieldValue(this.llmReviewResult(), ['max_score', 'maxScore', 'maximum_score', 'maximum', '만점'], 0));
    }

    public hasLlmReviewResult(): boolean {
        const result = this.llmReviewResult();
        return this.llmReviewMaxScore() > 0 && (!!result.generated_at || this.llmReviewItems().length > 0 || this.llmReviewScore() > 0);
    }

    public llmReviewItems(): any[] {
        const items = this.llmReviewResult()?.items;
        return Array.isArray(items) ? items : [];
    }
}

export default PageInvestmentCommitteeComponent;